var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogobtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.83 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #ea0085;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.83,1H40.75C20.16,1,3.22,16.55,1,36.55h49.65l-14.41-14.41c-1.74-1.74-1.74-4.56,0-6.3,1.74-1.74,4.56-1.74,6.3,0l21.91,21.91c.9.9,1.32,2.08,1.3,3.26.03,1.17-.4,2.36-1.3,3.26l-21.91,21.91c-1.74,1.74-4.56,1.74-6.3,0-1.74-1.74-1.74-4.56,0-6.3l14.41-14.41H1c2.22,19.99,19.16,35.55,39.75,35.55h241.08c22.09,0,40-17.91,40-40h0c0-22.09-17.91-40-40-40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobtn);
export default __webpack_public_path__ + "static/media/logobtn.36549dc56b12dbc8846136afe73f10c8.svg";
export { ForwardRef as ReactComponent };